const SELECT_BUTTON_CLASS_NAME = 'select-button';
const FORM_SELECT_BUTTON_CLASS_NAME = 'form-select-button';
const SELECT_MENU_CLASS_NAME = 'select-menu';
const FORM_SELECT_MENU_CLASS_NAME = 'form-select-menu';
const SUMMARY_FILTER_SELECT_CLASS_NAME = 'summary-filter-select';
const CURRENCY_PILL_SELECT_CLASS_NAME = 'currency-pill-select';
const COMPACT_SELECT_CLASS_NAME = 'compact-select';
const CHECKBOX_FORM_SELECT_MENU_CLASS_NAME = 'checkbox-form-select-menu';

export {
  SELECT_BUTTON_CLASS_NAME,
  FORM_SELECT_BUTTON_CLASS_NAME,
  SELECT_MENU_CLASS_NAME,
  FORM_SELECT_MENU_CLASS_NAME,
  SUMMARY_FILTER_SELECT_CLASS_NAME,
  CURRENCY_PILL_SELECT_CLASS_NAME,
  COMPACT_SELECT_CLASS_NAME,
  CHECKBOX_FORM_SELECT_MENU_CLASS_NAME,
};
